import React from "react";
import EditInstallerContainer from "../../containers/installers/EditInstallerContainer";
import Modal from "../../components/Modal";
import { useTranslation } from "react-i18next";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import ContactsForm from "../../forms/account/ContactsForm";

const Edit = ({ handleClose, open, contacts, isInstaller }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <Modal
      fullScreen={matches}
      open={open}
      onClose={handleClose}
      title={t("register.title_edit_contacts")}
    >
      {contacts ? (
        <EditInstallerContainer installer={contacts}>
          {({ onSubmit, installer }) => (
            <ContactsForm
              isInstaller={isInstaller}
              onSubmit={onSubmit}
              initialValues={installer.profile}
            />
          )}
        </EditInstallerContainer>
      ) : null}
    </Modal>
  );
};

export default Edit;
